import "./setupGlobalReact"; // must be first — sets window.React for react-apexcharts' UMD build
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import ApolloClient from "apollo-boost";
import { ApolloProvider } from "react-apollo";
import { getAuthorizedBranchIds } from "./utils/branchScope";
//const client = new ApolloClient({ uri: "https://api.rizee.in/graphql" });
// const client = new ApolloClient({ uri: "http://localhost:3008/graphql" });
// const client = new ApolloClient({ uri: "http://gdev.mylearningplus.in/graphql" });
// const client = new ApolloClient({ uri: "https://devcollegeapi2.rizee.in/graphql" });

// Branch scope (frontend guard): the backend may return every institution
// branch, so we filter any branch list in the response down to the branches the
// logged-in user is authorized for (from the login `branch_id` cookie). This
// applies to every query through this client, so all branch dropdowns app-wide
// show only the user's branches. Admins/unrestricted users have all branch ids
// in the cookie, so nothing is filtered out for them.
// Response field names (incl. the common frontend aliases of getBranches) that
// return a list of branch objects shaped { id, branch_name, ... }.
const BRANCH_LIST_FIELDS = new Set([
  "getBranches", "globalBranches", "getBranchesList",
  "getBranchArr", "getBranchesQuery", "getBranchesData", "getBranchOptions",
  "getBranchesDefaultValues", "getBranchNames", "getbranches",
]);
const branchScopeFetch = (uri, options) =>
  fetch(uri, options).then((res) => {
    const allowed = getAuthorizedBranchIds();
    if (!allowed.length) return res; // no scope info -> pass through unchanged
    return res.text().then((text) => {
      let json;
      try {
        json = JSON.parse(text);
      } catch (e) {
        return new Response(text, {
          status: res.status,
          statusText: res.statusText,
          headers: { "content-type": res.headers.get("content-type") || "application/json" },
        });
      }
      const allow = new Set(allowed.map(String));
      const scrub = (node) => {
        if (!node || typeof node !== "object") return;
        if (Array.isArray(node)) {
          node.forEach(scrub);
          return;
        }
        Object.keys(node).forEach((k) => {
          const v = node[k];
          if (BRANCH_LIST_FIELDS.has(k) && Array.isArray(v)) {
            node[k] = v.filter((b) => !b || b.id == null || allow.has(String(b.id)));
          } else {
            scrub(v);
          }
        });
      };
      if (json && json.data) scrub(json.data);
      return new Response(JSON.stringify(json), {
        status: res.status,
        statusText: res.statusText,
        headers: { "content-type": "application/json" },
      });
    });
  });

// API endpoint: REACT_APP_API_URL if set, otherwise the live college API for BOTH dev and
// production builds. (NODE_ENV is set by react-scripts: development for `npm start`,
// production for `npm run build`.) A production build must never point at localhost.
//
// This MUST stay env-driven. It was briefly hardcoded to the Cloud Run URL, which meant
// `npm start` sent every query through this client — the whole app, reports included — to
// the LIVE backend regardless of .env.development.local, so local backend changes were
// invisible while local edits ran against production data.
const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://capi.rizee.in/graphql";

const client = new ApolloClient({
  uri: API_URL,
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById("root"),
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
